
import request from '@/utils/request'

export default {
  getOrgByIp(data) {
    console.log('根据Ip获取机构信息 getOrgByIp。',data)
    return request({
      url: '/orgmanager/allow/getOrgByIp',
      method: 'post',
      data
    })
  },

  getOrgByUserInfo(data) {
    return request({
      url: '/orgmanager/allow/getOrgByUserInfo',
      method: 'post',
      data
    })
  },

  getuserInforByToken(data) {
    return request({
      url: '/orgmanager/allow/getuserInforByToken',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/orglogin.js